module.exports = __webpack_public_path__ + "static/img/real2.0185234.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/demo/real2.jpg
// module id = Olul
// module chunks = 1